import { Grid2 } from "@mui/material";
import React from "react";

import ChangeEmailSection from "./ChangeEmailSection";
import ChangePhoneSection from "./ChangePhoneSection";

const styles = (theme) => ({
  border: `1px solid ${theme.palette.border.blue}`,
  borderRadius: "8px",
  padding: "16px",
  "& .socialBox": {
    border: `1px solid ${theme.palette.border.blue}`,
    borderRadius: "8px",
    padding: "10px 16px",
    display: "flex",
    alignItems: "center",
    gap: "8px",
    "& a": {
      marginLeft: "auto",
    },
  },
});

const ChangeEmailPhone = ({ profileInfo }) => {
  return (
    <Grid2 sx={styles}>
      <Grid2
        container
        spacing={2}
        columns={{ xl: 12, lg: 12, md: 6, sm: 6, xs: 6 }}
      >
        <ChangeEmailSection profileInfo={profileInfo} />
        <ChangePhoneSection profileInfo={profileInfo} />
      </Grid2>
    </Grid2>
  );
};

export default ChangeEmailPhone;
